import { render } from "./payin.vue?vue&type=template&id=622ea231&scoped=true&ts=true"
import script from "./payin.vue?vue&type=script&lang=ts"
export * from "./payin.vue?vue&type=script&lang=ts"

import "./payin.vue?vue&type=style&index=0&id=622ea231&lang=less&scoped=true"
import "./payin.vue?vue&type=style&index=1&id=622ea231&lang=less"

import exportComponent from "/data/gitlab/pay.klicklpay.com/KlicklPaymentPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622ea231"]])

export default __exports__